import React from "react";
import { Box, Container } from "@mui/material";
import { Outlet } from "react-router-dom";
import Sidebar from "./Sidebar";
import Navigator from "./Navigator";

interface Props {
  paths: { text: string; to: string }[];
}

const Document = ({ paths }: Props) => {
  return (
    <Box display="flex">
      <Sidebar>
        <Navigator paths={paths} />
      </Sidebar>
      <Box component="main" flex={1}>
        <Container>
          <Outlet />
        </Container>
      </Box>
    </Box>
  );
};

export default Document;
